module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ts-carousel",
    on: {
      "mouseover": _vm.listEvent,
      "mouseout": _vm.listEvent
    }
  }, [_c('button', {
    staticClass: "ts-carousel-arrow left",
    class: ['is-' + _vm.arrow, 'is-' + _vm.arrowType],
    on: {
      "click": function($event) {
        _vm.arrowEvent(-1)
      }
    }
  }, [_c('span', {
    staticClass: "ts-arrow left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ts-carousel-list"
  }, [_c('div', {
    staticClass: "ts-carousel-track",
    style: (_vm.trackStyles)
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('button', {
    staticClass: "ts-carousel-arrow right",
    class: ['is-' + _vm.arrow, 'is-' + _vm.arrowType],
    on: {
      "click": function($event) {
        _vm.arrowEvent(1)
      }
    }
  }, [_c('span', {
    staticClass: "ts-arrow right"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "ts-carousel-dots",
    class: ['is-' + _vm.dots]
  }, [_vm._l((_vm.slides.length), function(n) {
    return [_c('li', {
      class: [n - 1 === _vm.currentIndex ? 'active' : ''],
      on: {
        "click": function($event) {
          _vm.dotsEvent('click', n - 1, $event)
        },
        "mouseover": function($event) {
          _vm.dotsEvent('hover', n - 1, $event)
        }
      }
    }, [_c('button')])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3d793c92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/carousel/carousel.vue
// module id = 824
// module chunks = 39